import axios from 'axios';

export const instance = axios.create({
  baseURL: process.env.REACT_APP_API,
});

instance.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem('token'); // 로컬스토리지면 401에러 발생해서 세션스토리지로 변경
    const requestConfig = { ...config };
    requestConfig.headers.withCredentials = true;
    if (token) {
      requestConfig.headers.Authorization = `Bearer ${token}`;
    }
    return requestConfig;
  },
  error => Promise.reject(error),
);
